/**
 * zLayers — single source of truth for z-index stacking across the
 * clinical workspace.
 *
 * Why this file exists
 * --------------------
 * Prior to the Widget Library MVP, the chart, half-disc, dialogs and
 * action-pending overlays all picked z-indices independently (`z-50`,
 * `z-[1200]`, `zIndex: 1100`, etc.). That made it impossible to reason
 * about which surface sits above which without grep-ing each file. The
 * Widget Library + Chart Plugin architecture coexists three persistent
 * surfaces (chart pane, widget rail, pending tasks below the form), so
 * the stacking order needs to be explicit and centralised.
 *
 * Stack (lowest → highest)
 * ------------------------
 *   1   Z_PAGE             page chrome / sticky headers
 *  10   Z_VISIT_BODY       scrollable form column
 * 900   Z_CHART_PANE       centered chart pane (NOT inset-0 anymore)
 * 1100  Z_WIDGET_RAIL      right-edge widget rail — above the chart
 * 1200  Z_WIDGET_OVERLAY   widget expanded to canvas/fullscreen
 * 1300  Z_DIALOG           confirm/picker modals
 * 1400  Z_TOAST            toasts, ephemeral notifications
 *
 * Consumers may use either the numeric token (`zIndex: Z_CHART_PANE`)
 * or the matching CSS-variable form for Tailwind arbitrary values
 * (`className="z-[var(--z-chart-pane)]"`). The CSS variables are
 * registered globally in `src/index.css`.
 */

export const Z_PAGE = 1;
export const Z_VISIT_BODY = 10;
export const Z_CHART_PANE = 900;
export const Z_WIDGET_RAIL = 1100;
export const Z_WIDGET_OVERLAY = 1200;
export const Z_DIALOG = 1300;
export const Z_TOAST = 1400;

export const Z_LAYERS = Object.freeze({
  page: Z_PAGE,
  visitBody: Z_VISIT_BODY,
  chartPane: Z_CHART_PANE,
  widgetRail: Z_WIDGET_RAIL,
  widgetOverlay: Z_WIDGET_OVERLAY,
  dialog: Z_DIALOG,
  toast: Z_TOAST,
});

export default Z_LAYERS;
